export enum SignupErrorDialogVariant {
  API_UNAVAILABLE = 'API_UNAVAILABLE',
  COMPLETION_UNSUCCESSFUL = 'COMPLETION_UNSUCCESSFUL',
}

export const SIGNUP_ERROR_DIALOG_COPY = {
  [SignupErrorDialogVariant.API_UNAVAILABLE]: {
    title: "Let's try this again",
    description:
      "We're having trouble connecting with our account verification partner. Please try again in a few minutes.",
  },
  [SignupErrorDialogVariant.COMPLETION_UNSUCCESSFUL]: {
    title: 'Unable to complete account setup',
    description:
      'Please try again in a few minutes. If the problem persists, please contact Customer Care so we can complete your setup immediately.',
  },
} as const;

export const SIGNUP_ERROR_DIALOG_BUTTON_TEXT = 'Got it';
